import IsAuthenticated from "@/permissions/IsAuthenticated";
import HasSpecialPermissions from "@/permissions/HasSpecialPermissions";

export default [
  {
    path: "/settings",
    name: "settings",
    component: () =>
      import(
        /* webpackChunkName: "settings" */ "@/modules/settings/views/Settings.vue"
      ),
    meta: {
      permissions: [IsAuthenticated(), HasSpecialPermissions()]
    }
  }
];
